import { router } from 'expo-router'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Button } from '../elements/button/default'
import { Header } from '../elements/header'
import { Icon } from '../elements/media/Icon'
import { Typography } from '../elements/text/Typography'
import { ICON } from '../general/enums/icons'
import { useRoutes } from '../general/utils/routes'

export default () => {
  const { routes } = useRoutes()
  return (
    <View className="h-screen w-screen">
      <Header showTabs />
      <View className="flex-1 items-center justify-center gap-4">
        <Icon name={ICON.NOT_FOUND} className="mx-auto h-auto w-4/5 color-secondary-label-faded md:w-2/5" />
        <Typography bold size="xl">
          <FormattedMessage id="error.404.title" />
        </Typography>
        <Typography size="lg">
          <FormattedMessage id="error.404.message" />
        </Typography>
        <Typography italic contrast="low">
          <FormattedMessage id="error.404.quote" />
        </Typography>

        <Button
          onPress={() => router.navigate(routes.communities())}
          colors="primary"
          variant="faded"
          endIcon={ICON.SEARCH}
        >
          <Typography colors="primary" contrast="low">
            <FormattedMessage id="community.communities.view-all" />
          </Typography>
        </Button>
      </View>
    </View>
  )
}
